import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1),
    borderBottom: '1px solid rgba(255, 255, 255, 0.3)',
    lineHeight: 1,
  },
  button: {
    border: '1px solid rgba(255, 255, 255, 0.3)',
    borderRadius: '50%',
    display: 'inline-block',
    height: 10,
    width: 10,
    marginRight: theme.spacing(1),
  },
}));

const CodeBlockToolbar = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <span className={classes.button} />
      <span className={classes.button} />
      <span className={classes.button} />
    </div>
  );
};

export default CodeBlockToolbar;
